import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Check } from 'components/form/private/controls/Check';
import { Icon } from 'components/Icon';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { React } from 'libs/react';
import './FormCheck.scss';
/**
 * @component FormCheck
 * @since 1.0.0
 */
export function FormCheck(props) {
    let { name, size, style, label, infos, picto, error, required, optional, disabled, prefix, suffix, silenced } = Object.assign({ style: 'normal', size: 'normal' }, props);
    const form = useForm();
    const node = useRef(null);
    const [ident] = useIdent('form-check');
    const [checked, setChecked] = useValue(name, props.checked, false);
    const [focused, setFocused] = useState(false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(checked) {
        setChecked(checked);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(checked);
        }
    }, [checked]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-check', 'form-check--' + size, 'form-check--' + style, { 'form-check--is-required': required }, { 'form-check--is-optional': optional }, { 'form-check--is-disabled': disabled }, { 'form-check--is-silenced': silenced }, { 'form-check--is-focused': focused }, { 'form-check--is-checked': checked }, { 'form-check--has-label': label }, { 'form-check--has-picto': picto }, { 'form-check--has-error': error }, props.className);
    if (silenced) {
        error = null;
    }
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-check-field" },
            React.createElement("div", { className: "form-check-field-head" },
                React.createElement(FormFieldLabel, { className: "form-check-label", style: style, label: label, ident: ident, required: required, optional: optional, disabled: disabled }),
                React.createElement(FormFieldInfos, { className: "form-check-infos", style: style, infos: infos })),
            React.createElement("div", { className: "form-check-field-body" },
                prefix && React.createElement("div", { className: "form-check-prefix" }, prefix),
                React.createElement(Check, { name: name, outer: node, ident: ident, checked: checked, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange }),
                React.createElement(When, null,
                    React.createElement(Case, { is: picto },
                        React.createElement(Icon, { className: "form-check-picto", value: picto })),
                    React.createElement(Else, null,
                        React.createElement(Icon, { value: "fal check", className: "form-check-field-body-bar" }))),
                suffix && React.createElement("div", { className: "form-check-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
